import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('accessories', storeModule.createStoreModule('accessories'))
